/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-unsafe-storage */
'use es6';

import { Map as ImmutableMap } from 'immutable';
import SafeStorage from 'SafeStorage';
import ActionTypes from '../actions/ActionTypes';
const INVITE_TEAM_ALERT_KEY = 'learning_center:invite_team_alert';

function getAsObject(key, defaultValue = false) {
  const fromStorage = SafeStorage.getItem(key);
  return fromStorage ? JSON.parse(fromStorage) : defaultValue;
}

const initialState = ImmutableMap({
  hideInviteMember: getAsObject(INVITE_TEAM_ALERT_KEY)
});
export default function DismissedAlerts(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.DISMISS_INVITE_TEAM_ALERT:
      {
        SafeStorage.setItem(INVITE_TEAM_ALERT_KEY, true);
        return state.merge({
          hideInviteMember: true
        });
      }

    default:
      return state;
  }
}